import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  EditButton,
  DeleteButton,
  SearchInput,
  FilterButton,
  CreateButton,
  TopToolbar,
  ExportButton,
  SelectInput,
} from "react-admin";

const userFilters = [
  <SearchInput source="q" alwaysOn key="q" />,
  <SelectInput
    source="role"
    label="Ruolo"
    key="role"
    choices={[
      { id: "admin", name: "Amministratore" },
      { id: "user", name: "Utente" },
    ]}
  />,
];

function ListActions() {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <ExportButton />
    </TopToolbar>
  );
}

export function UserList() {
  return (
    <List
      filters={userFilters}
      actions={<ListActions />}
      sort={{ field: "email", order: "ASC" }}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <EmailField source="email" label="Email" />
        <TextField source="role" label="Ruolo" />
        <DateField source="created_at" label="Creato" showTime />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
}
